function showMore() {
    // Inspiration
    // document.querySelectorAll('.inspiration-cards').forEach(function(cards) {
    //     const children = cards.children;
    //     const showAmount = 4;
    //     const moreBtn = document.querySelector('.inspiration-moreBtn');

    //     for (let i = 0; i < children.length; i++) {
    //         const card = children[i];
    //         if (i < showAmount) {
    //             card.classList.add('show')
    //         }
    //     }

    //     if (children.length <= showAmount) {
    //         const btnTexts = moreBtn.children;

    //         for (let i = 0; i < btnTexts.length; i++) {
    //             const btnText = btnTexts[i];
    //             btnText.classList.remove('showBtnText');
    //         }
    //     }

    //     moreBtn.addEventListener('click', () => {
    //         const btnTexts = moreBtn.children;
            
    //         for (let i = 0; i < children.length; i++) {
    //             const card = children[i];
    //             if (i >= showAmount) {
    //                 card.classList.toggle('show');
    //             }
    //         }
            
    //         for (let i = 0; i < btnTexts.length; i++) {
    //             const btnText = btnTexts[i];
    //             btnText.classList.toggle('showBtnText');
    //         }
    //     })
    // })

    // Events 
    document.querySelectorAll('.event-cards').forEach(function(cards) {
        const children = cards.children;
        const showAmount = 4;
        const moreBtn = document.querySelector('.event-moreBtn');

        for (let i = 0; i < children.length; i++) {
            const card = children[i];
            if (i < showAmount) {
                card.classList.add('show')
            }
        }

        if (children.length <= showAmount) {
            const btnTexts = moreBtn.children;

            for (let i = 0; i < btnTexts.length; i++) {
                const btnText = btnTexts[i];
                btnText.classList.remove('showBtnText');
            }
        }

        moreBtn.addEventListener('click', () => {
            const btnTexts = moreBtn.children;
            
            for (let i = 0; i < children.length; i++) {
                const card = children[i];
                if (i >= showAmount) {
                    card.classList.toggle('show');
                }
            }
            
            for (let i = 0; i < btnTexts.length; i++) {
                const btnText = btnTexts[i];
                btnText.classList.toggle('showBtnText');
            }
        })
    });

    // Employees
    document.querySelectorAll('.section__employee-gallery').forEach(function(employeeGallery, i) {
        const titleBtn = employeeGallery.querySelector('.employee-title');
        const cards = employeeGallery.querySelector('.employee-cards');
        
        titleBtn.addEventListener('click', () => {
            titleBtn.classList.toggle('employee-title--open');
            titleBtn.setAttribute('aria-expanded', titleBtn.classList.contains('employee-title--open'));
            cards.classList.toggle("employee-cards--open");
        })

        if (i === 0) {
            titleBtn.classList.toggle('employee-title--open');
            titleBtn.setAttribute('aria-expanded', 'true');
            cards.classList.toggle("employee-cards--open");
        }
    });

        // Addresses
        document.querySelectorAll('.addresses').forEach(function(employeeGallery, i) {
            const titleBtn = employeeGallery.querySelector('.addresses-title');
            const cards = employeeGallery.querySelector('.addresses-cards');
            
            titleBtn.addEventListener('click', () => {
                titleBtn.classList.toggle('addresses-title--open');
                cards.classList.toggle("addresses-cards--open");
            })
    
            if (i === 0) {
                titleBtn.classList.toggle('addresses-title--open');
                cards.classList.toggle("addresses-cards--open");
            }
        });
};